import { CommonResponse, get, post } from './common.ts'

/**
 * (01)
 * 학생 목록 조회
 */

// GET /students
interface GetStudentsRequest {
  grade: number
  classNumber: number
  majorGroup: string
  name: string
}
interface GetStudentsResponse {
  id: string
  studentId: string
  admissionYear: number
  grade: number
  classNumber: number
  studentNumber: number
  name: string
  status: string
  schoolId: string
  majorGroup: string
}

export const getStudents = async (
  request: GetStudentsRequest,
): Promise<CommonResponse<GetStudentsResponse>> => {
  const grade = request.grade ? `grade=${request.grade}` : ''
  const classNumber = request.classNumber ? `classNumber=${request.classNumber}` : ''
  const majorGroup = request.majorGroup ? `majorGroup=${request.majorGroup}` : ''
  const name = request.name ? `name=${request.name}` : ''

  return await get(`/students?${grade}&${classNumber}&${majorGroup}&${name}`)
}

/**
 * (02)
 * 학생 로그인
 */

//POST /students/signin
interface PostStudentsSignInRequest {
  grade: number
  classNumber: number
  studentNumber: number
  password: string
  schoolId: string
}

export const postStudentsSignIn = async (
  body: PostStudentsSignInRequest,
): Promise<CommonResponse<null>> => {
  return await post('/students/signin', body)
}
